import React, { useEffect, useState } from 'react'
import { Slider } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import './SelectYourVehicle.css'
import { GpButton } from '../../components/gp'

const TICKS = [
    { value: 10, label: '10' },
    { value: 100, label: '100' },
    { value: 200, label: '200' },
    { value: 300, label: '300' },
    { value: 400, label: '400+' },
]

const BrandSlider = withStyles({
    root: {
        color: 'var(--gp-brand)',
        height: 6,
        padding: '18px 0',
    },
    rail: {
        height: 4,
        borderRadius: 2,
        backgroundColor: 'var(--gp-hairline)',
        opacity: 1,
    },
    track: {
        height: 4,
        borderRadius: 2,
        backgroundColor: 'var(--gp-brand)',
    },
    thumb: {
        width: 22,
        height: 22,
        marginTop: -9,
        marginLeft: -11,
        backgroundColor: '#FFFFFF',
        border: '4px solid var(--gp-brand)',
        boxShadow: '0 2px 6px rgba(11,41,38,0.18)',
        '&:focus, &:hover, &$active': {
            boxShadow: '0 2px 8px rgba(0,83,57,0.3)',
        },
    },
    mark: {
        width: 2,
        height: 8,
        backgroundColor: 'var(--gp-hairline)',
        marginTop: -2,
    },
    markActive: {
        backgroundColor: 'var(--gp-brand)',
    },
    markLabel: {
        font: 'var(--gp-caption)',
        color: 'var(--gp-ink-mute)',
        marginTop: 6,
    },
    active: {},
})(Slider)

const RangeSelect = (props) => {
    const [milesPerWeek, setMilesPerWeek] = useState(props.milesPerWeek || 100)

    useEffect(() => {
        if (props.milesPerWeek) setMilesPerWeek(props.milesPerWeek)
    }, [])

    const displayValue = milesPerWeek >= 400 ? '400+' : milesPerWeek

    return (
        <div style={{ maxWidth: 560, margin: '0 auto' }}>
            <div
                style={{
                    background: 'var(--gp-card)',
                    border: '1px solid var(--gp-hairline)',
                    borderRadius: 'var(--gp-r-lg)',
                    boxShadow: 'var(--gp-shadow-sm)',
                    padding: '24px 28px 28px',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        marginBottom: 18,
                    }}
                >
                    <div
                        style={{
                            font: '500 11px/1 var(--gp-font)',
                            letterSpacing: 0.6,
                            textTransform: 'uppercase',
                            color: 'var(--gp-ink-mute)',
                        }}
                    >
                        Weekly mileage
                    </div>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                        <span
                            style={{
                                font: '500 44px/1 var(--gp-font)',
                                letterSpacing: -1,
                                color: 'var(--gp-ink)',
                            }}
                        >
                            {displayValue}
                        </span>
                        <span
                            style={{
                                font: 'var(--gp-caption)',
                                color: 'var(--gp-ink-mute)',
                            }}
                        >
                            miles
                        </span>
                    </div>
                </div>

                <BrandSlider
                    aria-label="Miles per week"
                    value={milesPerWeek}
                    onChange={(_, value) => setMilesPerWeek(value)}
                    step={10}
                    min={10}
                    max={400}
                    marks={TICKS}
                />
            </div>

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: 24,
                }}
            >
                <GpButton
                    variant="primary"
                    onClick={() => props.selectMilesPerWeek(milesPerWeek)}
                    style={{ minWidth: 200 }}
                >
                    Continue
                </GpButton>
            </div>
        </div>
    )
}

export default RangeSelect
